import { render } from "./SectionNav.vue?vue&type=template&id=d83a9e76&scoped=true"
import script from "./SectionNav.vue?vue&type=script&lang=js"
export * from "./SectionNav.vue?vue&type=script&lang=js"

import "./SectionNav.vue?vue&type=style&index=0&id=d83a9e76&scoped=true&lang=css"

import exportComponent from "/Users/bellakwon/Desktop/thesis01/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d83a9e76"]])

export default __exports__